import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userInfo: null,
        showLogin:false,
        IsLogin:false,
        errormsg:{
        }
    },
    mutations: {
        set_account (state, platform) {
            state.userInfo = platform;
        },
        set_showLogin (state, platform) {
            state.showLogin = platform;
        },
        set_IsLogin(state, platform) {
            state.IsLogin = platform;
        },
        set_userInfo(state, platform) {
            state.userInfo = platform;
        },
        set_msg(state,platform){
            state.errormsg = platform;
            var times = 5
            var timer = setInterval(()=>{
                times--
                if(times===0){
                    state.errormsg = {}
                    clearInterval(timer)
                }
              },1000)
        }
    },
    actions: {
        setAccount ({commit}, platform) {
            commit('set_account', platform);
        },
        setShowLogin ({commit}, platform) {
            commit('set_showLogin', platform);
        },
        setLogin ({commit}, platform) {
            commit('set_IsLogin', platform);
        },
        setUserInfo({commit}, platform) {
            commit('set_userInfo', platform);
        },
        setMsg ({commit}, platform) {
            commit('set_msg', platform);
        },
    },
    getters: {
       // getCount: state => state.count，
        getInfo: state => state.userInfo,
        getstate: state=> state.showLogin

    }
})

export default store